import { any, bool, oneOf, string } from 'prop-types';
import { memo } from 'react';
import styled from 'styled-components';
const StyledLabel = styled.label`
   align-items: center;
   color: #949494;
   display: flex;
   font-size: 14px;
   font-weight: 500;
   margin: 0 0 4px 0;
   &[data-size='large'] {
      font-size: 16px;
      font-weight: 500;
      margin: 0 0 5px 0;
   }
   &[data-size='small'] {
      font-size: 12px;
      font-weight: 400;
      margin: 0 0 3px 0;
   }
   & strong {
      color: #d32f2f;
      font-weight: 700;
      margin: 0 0 0 4px;
   }
`;
const Label = memo(
   ({ children, isRequired = false, htmlFor = '', size = 'medium' }) => (
      <StyledLabel htmlFor={htmlFor} data-size={size}>
         {children}
         {isRequired && <strong>*</strong>}
      </StyledLabel>
   ),
);
Label.propTypes = {
   children: any,
   htmlFor: string,
   isRequired: bool,
   size: oneOf(['large', 'medium', 'small']),
};
export default Label;
